module.exports = __webpack_public_path__ + "img/hdfc-bank1.1f207cf5.jpg";